import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const home = async (params: object) => {
  return await GET({ url: Api.home, params, showError: false })
}
